import { createComponent } from '@lit-labs/react';
import React from 'react';

export class BBaseIconMatrixDS extends HTMLElement {
  icon?: string;
  state?: string;
  alt?: string;
  constructor() {
    super();
  }
}

export const BaseIconMatrix = createComponent(React, 'base-icon-matrix', BBaseIconMatrixDS, {});
